<script>
    import Router from "svelte-spa-router";
    import Calculator from "./Calculator.svelte";
    export let params='';
    params = params

    const routes = {
        "/Product/:productId": Calculator,
        "/FactorySettings/:factorySettingsId": Calculator,
    };
</script>

<Router {routes} prefix="/calculator" />
